(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('ControlPauseService', ControlPauseService);

  ControlPauseService.$inject = ['$resource'];

	 function ControlPauseService ($resource) {
    return $resource(apiUrl + '/control-pause/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      changeReason: { url: apiUrl + '/control-pause/change-reason/:id', method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      userIsPaused: { url: apiUrl + '/control-pause/user-paused', method: 'POST', params: {}, isArray: false }

    });
  }
})();
